import { APP_TYPE, WEBVIEW_TYPES } from '@/lib/consts.ts'
import { useLogger } from '@booksy-com/vue-tools'

const logger = useLogger('ios-tablet-identity')

const IOS_TABLET_IDENTITY_KEY = 'identity.local'

type IosTabletStore = {
  state: {
    app: { webView: string; appType: string }
    identity: unknown
  }
}

const isIosTablet = (store: IosTabletStore): boolean => {
  return store.state.app.webView === WEBVIEW_TYPES.IOS
    && store.state.app.appType === APP_TYPE.TABLET
}

export const saveIosTabletIdentity = (store: IosTabletStore): void => {
  if (isIosTablet(store)) {
    logger.debug(`saving identity into local storage`, store.state.identity)
    localStorage.setItem(IOS_TABLET_IDENTITY_KEY, JSON.stringify(store.state.identity))
  }
}

export const loadIosTabletIdentity = (store: IosTabletStore): unknown => {
  if (isIosTablet(store)) {
    logger.debug(`loading identity from local storage`)
    const localIdentity = localStorage.getItem(IOS_TABLET_IDENTITY_KEY)
    if (localIdentity === null) return
    try {
      return JSON.parse(localIdentity) as unknown
    } catch {
    }
  }
}

export const clearIosTabletIdentity = (): void => {
  localStorage.removeItem(IOS_TABLET_IDENTITY_KEY)
}
